import Component from '../colorz/Component';
import intlTelInput from 'intl-tel-input';
import FixScroll from '@utils/html/FixScroll';

export default class FamilyProfile extends Component {
	onInit(el) {
		this.el = el;
		this.loader = this.el.querySelector('.js-loader');
		this.customerEmail = this.el.dataset.customerEmail;
		this.customerIdField = this.el.querySelector('.js-customer-id-klaviyo');
		this.customerFirstnameField = this.el.querySelector(
			'.js-customer-firstname',
		);
		this.customerLastnameField = this.el.querySelector('.js-customer-lastname');
		this.customerPhoneField = this.el.querySelector('.js-customer-phone');
		this.customerBirthdayField = this.el.querySelector('.js-customer-birthday');
		this.customerDuedateField = this.el.querySelector('.js-customer-duedate');
		this.checkboxConsent = this.el.querySelector('.js-checkbox-consent');
		this.errorConsent = this.el.querySelector('.js-error-consent');
		this.errorFirstName = this.el.querySelector('.js-first-name-error');
		this.errorLastName = this.el.querySelector('.js-last-name-error');
		this.btnSave = this.el.querySelector('.js-save-infos');
		this.addMember = this.el.querySelector('.js-add-member');
		this.btnCancel = this.el.querySelector('.js-btn-cancel');
		this.membersContainer = this.el.querySelector('.js-members-container');
		this.successMsg = this.el.querySelector('.js-success-msg');
		this.errorMsg = this.el.querySelector('.js-error-msg');
		this.mappingSkinRelationship =
			JSON.parse(
				this.el.querySelector('.js-mapping_skin_relationship')?.textContent ||
					'null',
			) || {};
		this.popinValidateInfos = this.el.querySelector('.js-popin-validate-infos');
		this.validateBtns = this.el.querySelectorAll('.js-validate-infos');
		this.route = '/apps/clrz/klaviyo/customer';

		this.memberCount = 0;
		this.members = [];
	}

	get cookieName() {
		return 'account-edit-infos-hidden-' + (this.customerIdField?.value || '');
	}

	onReady() {
		this.getCustomerInfosKlaviyo();

		if (this.addMember) {
			this.addMember.addEventListener('click', (e) => {
				e.preventDefault();
				this.addNewMember();
			});
		}

		if (this.btnSave) {
			this.btnSave.addEventListener('click', (e) => {
				e.preventDefault();

				if (this.checkboxConsent && !this.checkboxConsent.checked) {
					this.errorConsent.classList.remove('u-hidden');
				} else {
					if (!this.errorConsent.classList.contains('u-hidden')) {
						this.errorConsent.classList.add('u-hidden');
					}

					if (this.validateRequiredFields()) {
						this.loader.classList.remove('u-hidden');
						this.postCustomerInfosKlaviyo();
					}
				}
			});
		}

		if (this.btnCancel) {
			this.btnCancel.addEventListener('click', (e) => {
				e.preventDefault();
				this.loader.classList.remove('u-hidden');
				this.getCustomerInfosKlaviyo();
			});
		}
	}

	getCustomerInfosKlaviyo() {
		fetch(this.route)
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
			})
			.then((data) => {
				let customerInfos = data;

				if (customerInfos?.profile?.id && this.customerIdField) {
					this.customerIdField.value = customerInfos.profile.id;
				}

				if (
					this.checkIfHasInfos(customerInfos.profile) &&
					!this.getCookie(this.cookieName)
				) {
					this.showPopin();
					this.closePopin();
				}

				if (customerInfos && customerInfos.success) {
					this.displayInfos(customerInfos);
					this.intlTelInput(this.customerPhoneField);
					this.loader.classList.add('u-hidden');
					if (!this.getCookie(this.cookieName)) {
						this.setCookie(this.cookieName, 'true', 365 * 10);
					}
				}
			});
	}

	postCustomerInfosKlaviyo() {
		fetch(this.route, {
			headers: {'Content-Type': 'application/json'},
			method: 'POST',
			body: JSON.stringify(this.payLoadCustomerInfos()),
		})
			.then((response) => {
				response.json();
			})
			.then(() => {
				this.loader.classList.add('u-hidden');
				this.successMsg.classList.remove('u-hidden');
			})
			.catch((error) => {
				this.errorMsg.classList.remove('u-hidden');
			});
	}

	displayInfos(customerInfos) {
		if (customerInfos.profile.id) {
			this.customerIdField.value = customerInfos.profile.id;
		}

		if (customerInfos.profile.first_name) {
			this.customerFirstnameField.value = customerInfos.profile.first_name;
		}

		if (customerInfos.profile.last_name) {
			this.customerLastnameField.value = customerInfos.profile.last_name;
		}

		if (customerInfos.profile.phone_number) {
			this.customerPhoneField.value = customerInfos.profile.phone_number;
		}

		if (customerInfos.profile.birth_date) {
			this.customerBirthdayField.value = customerInfos.profile.birth_date;
		}

		if (customerInfos.profile.due_date) {
			this.customerDuedateField.value = customerInfos.profile.due_date;
		}

		if (
			customerInfos.profile.childs &&
			customerInfos.profile.childs.length > 0
		) {
			this.displayMembers(customerInfos.profile.childs);
		} else {
			this.ensureFirstMemberExists();
		}
	}

	displayMembers(members) {
		this.members = [];

		const maxMembers = Math.max(1, members.length);

		for (let index = 0; index < maxMembers; index++) {
			const memberIndex = index + 1;
			this.memberCount = Math.max(this.memberCount, memberIndex);

			let memberElement = this.el.querySelector(`[data-member-${memberIndex}]`);

			if (!memberElement) {
				memberElement = this.createMemberElement(memberIndex);
				this.membersContainer.appendChild(memberElement);
			}

			const nameField = memberElement.querySelector(
				`[data-name-member-${memberIndex}]`,
			);
			const dobField = memberElement.querySelector(
				`[data-member-dob-${memberIndex}]`,
			);
			const skinTypeField = memberElement.querySelector(
				`[data-skintype-member-${memberIndex}]`,
			);
			const relationshipField = memberElement.querySelector(
				`[data-relationship-member-${memberIndex}]`,
			);

			const member = members[index];
			if (member) {
				if (nameField && member.child_name) {
					nameField.value = member.child_name;
				}
				if (dobField && member.child_date_of_birth) {
					dobField.value = member.child_date_of_birth;
				}
				if (skinTypeField && member.child_skin_type) {
					let skinTypeKey = null;

					if (this.mappingSkinRelationship?.skin_type) {
						skinTypeKey = this.findKeyByValue(
							this.mappingSkinRelationship.skin_type,
							member.child_skin_type,
						);
					}

					skinTypeField.value = skinTypeKey || member.child_skin_type || '';
				}

				if (relationshipField && member.child_relationship_type) {
					let relationshipKey = null;

					if (this.mappingSkinRelationship?.relationship_type) {
						relationshipKey = this.findKeyByValue(
							this.mappingSkinRelationship.relationship_type,
							member.child_relationship_type,
						);
					}

					relationshipField.value =
						relationshipKey || member.child_relationship_type || '';
				}

				this.members.push({
					index: memberIndex,
					data: member,
				});
			} else {
				if (memberIndex === 1) {
					this.members.push({
						index: memberIndex,
						data: null,
					});
				}
			}

			this.attachMemberEventListeners(memberIndex);
		}
	}

	ensureFirstMemberExists() {
		if (this.memberCount === 0) {
			this.memberCount = 1;
			let memberElement = this.el.querySelector(`[data-member-1]`);

			if (!memberElement) {
				memberElement = this.createMemberElement(1);
				this.membersContainer.appendChild(memberElement);
			}

			this.attachMemberEventListeners(1);

			this.members.push({
				index: 1,
				data: null,
			});
		}
	}

	collectMembersData() {
		const membersData = [];

		for (let i = 1; i <= this.memberCount; i++) {
			const memberElement = this.el.querySelector(`[data-member-${i}]`);

			if (memberElement && !memberElement.classList.contains('u-hidden')) {
				const nameField = memberElement.querySelector(
					`[data-name-member-${i}]`,
				);
				const dobField = memberElement.querySelector(`[data-member-dob-${i}]`);
				const skinTypeField = memberElement.querySelector(
					`[data-skintype-member-${i}]`,
				);
				const relationshipField = memberElement.querySelector(
					`[data-relationship-member-${i}]`,
				);

				if (
					nameField?.value ||
					dobField?.value ||
					skinTypeField?.value ||
					relationshipField?.value
				) {
					const selectedSkinTypeText =
						skinTypeField?.value && skinTypeField.selectedIndex > 0
							? skinTypeField.selectedOptions[0]?.text || ''
							: '';

					const selectedRelationshipText =
						relationshipField?.value && relationshipField.selectedIndex > 0
							? relationshipField.selectedOptions[0]?.text || ''
							: '';

					membersData.push({
						child_name: nameField?.value || '',
						child_date_of_birth: dobField?.value || '',
						child_skin_type: selectedSkinTypeText,
						child_relationship_type: selectedRelationshipText,
					});
				}
			}
		}

		return membersData;
	}

	payLoadCustomerInfos() {
		const idKlaviyo = this.customerIdField?.value || '';
		const firstName = this.customerFirstnameField?.value || '';
		const lastName = this.customerLastnameField?.value || '';
		const phoneInput = this.customerPhoneField?.value || '';

		// --- GET DIAL CODE FROM EXISTING INTL-TEL-INPUT INSTANCE ---
		const itiInstance = window.customerPhoneITI;
		let fullPhoneNumber = phoneInput;

		if (itiInstance) {
			const dialCode = itiInstance.getSelectedCountryData().dialCode;
			// Remove leading 0 from local number and prepend dial code with '+'
			fullPhoneNumber = `+${dialCode}${phoneInput.replace(/^0+/, '')}`;
		}

		const birthDate = this.customerBirthdayField?.value || '';
		const dueDate = this.customerDuedateField?.value || '';

		const customerData = {
			id: idKlaviyo,
			email: this.customerEmail,
			phone_number: fullPhoneNumber, // <-- now includes +dialCode
			first_name: firstName,
			last_name: lastName,
			birth_date: birthDate,
			due_date: dueDate,
			childs: this.collectMembersData(),
		};

		return customerData;
	}

	addNewMember() {
		this.memberCount++;

		let memberElement = this.el.querySelector(
			`[data-member-${this.memberCount}]`,
		);

		if (memberElement) {
			memberElement.classList.remove('u-hidden');
		} else {
			memberElement = this.createMemberElement(this.memberCount);

			this.membersContainer.appendChild(memberElement);
		}

		this.attachMemberEventListeners(this.memberCount);
	}

	createMemberElement(memberIndex) {
		const memberDiv = document.createElement('div');
		memberDiv.setAttribute(`data-member-${memberIndex}`, '');
		memberDiv.classList.add('u-mt-30');
		memberDiv.innerHTML = `
			<div class="u-flex u-justify-between u-mb-15">
				<span data-member-number class="t-text t-text--semibold">${
					window.accountProfile.customer_member_label
				} ${memberIndex}</span>
				${
					memberIndex > 1
						? `
				<button class="js-delete-member" data-delete-member-${memberIndex}>
					<svg width="26px" height="26px" class="c-icon " viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill="var(--blue)" d="M17.197 8.59a.805.805 0 0 0-.804.801v12.601a2.414 2.414 0 0 1-2.41 2.405h-1.445V9.39a.805.805 0 0 0-.803-.802.805.805 0 0 0-.803.802v15.006H7.075V9.39a.805.805 0 0 0-.803-.802.805.805 0 0 0-.803.802v15.006H4.024a2.414 2.414 0 0 1-2.41-2.405v-12.6a.805.805 0 0 0-.803-.803.805.805 0 0 0-.803.802v12.601C.008 24.204 1.807 26 4.024 26h9.96A4.014 4.014 0 0 0 18 21.992v-12.6a.8.8 0 0 0-.803-.803ZM17.197 4.072H14.2v-.064C14.2 1.796 12.4 0 10.185 0h-2.37A4.013 4.013 0 0 0 3.8 4.008v.064H.803A.805.805 0 0 0 0 4.874c0 .44.361.801.803.801h16.394c.442 0 .803-.36.803-.801a.8.8 0 0 0-.803-.802Zm-4.595 0H5.414v-.064a2.414 2.414 0 0 1 2.41-2.405h2.369a2.414 2.414 0 0 1 2.41 2.405v.064Z"></path>
					</svg>
				</button>
				`
						: ''
				}
			</div>
			<div class="u-flex u-flex-col xl:u-flex-row u-gap-12">
				<div class="xl:u-w-1/2">
					<label for="member-name-${memberIndex}">${
			window.accountProfile.customer_first_name
		}</label>
					<input
						class="u-mt-10 js-member-name"
						data-name-member-${memberIndex}
						type="text"
						id="member-name-${memberIndex}"
						name="member[name]"
						value=""
						placeholder="${window.accountProfile.customer_first_name}"
					>
				</div>
				<div class="xl:u-w-1/2">
					<label for="member-birthday-${memberIndex}">${
			window.accountProfile.customer_date_of_birth
		}</label>
					<input
						class="u-mt-10 input-calendar js-customer-birthday"
						data-member-dob-${memberIndex}
						type="date"
						id="member-birthday-${memberIndex}"
						name="member[birthday]"
						placeholder="${window.accountProfile.customer_date_of_birth}"
					>
				</div>
			</div>
			<div class="u-flex u-flex-col xl:u-flex-row u-gap-12 u-mt-20">
				<div class="xl:u-w-1/2">
					<label for="member-skintype-${memberIndex}">${
			window.accountProfile.customer_skin_type
		}</label>
					<select
						class="input u-mt-10 js-member-skintype"
						name="member[skintype]"
						id="member-skintype-${memberIndex}"
						data-skintype-member-${memberIndex}
					>
						<option>${window.accountProfile.choose_option}</option>
						<option value="normal_skin">${
							window.accountProfile.customer_normal_skin
						}</option>
						<option value="dry_skin">${window.accountProfile.customer_dry_skin}</option>
						<option value="atopy_skin">${window.accountProfile.customer_atopy_skin}</option>
						<option value="sensitive_skin">${
							window.accountProfile.customer_sensitive_skin
						}</option>
					</select>
				</div>
				<div class="xl:u-w-1/2">
					<label for="member-relationship-${memberIndex}">${
			window.accountProfile.customer_relationship
		}</label>
					<select
						class="input u-mt-10 js-member-relationship"
						name="member[relationship]"
						id="member-relationship-${memberIndex}"
						data-relationship-member-${memberIndex}
					>
						<option>${window.accountProfile.choose_option}</option>
						<option value="partner">${window.accountProfile.customer_partner}</option>
						<option value="son">${window.accountProfile.customer_son}</option>
						<option value="daughter">${window.accountProfile.customer_daughter}</option>
					</select>
				</div>
			</div>
		`;

		return memberDiv;
	}

	attachMemberEventListeners(memberIndex) {
		const deleteBtn = this.el.querySelector(
			`[data-delete-member-${memberIndex}]`,
		);
		if (deleteBtn) {
			deleteBtn.addEventListener('click', (e) => {
				e.preventDefault();
				this.deleteMember(memberIndex);
			});
		}
	}

	deleteMember(memberIndex) {
		const memberElement = this.el.querySelector(`[data-member-${memberIndex}]`);
		if (memberElement) {
			memberElement.remove();

			this.members = this.members.filter(
				(member) => member.index !== memberIndex,
			);
		}

		this.reindexMembers(memberIndex);
	}

	reindexMembers(deletedIndex) {
		for (let i = deletedIndex + 1; i <= this.memberCount; i++) {
			const memberElement = this.el.querySelector(`[data-member-${i}]`);

			if (memberElement) {
				const newIndex = i - 1;

				memberElement.removeAttribute(`data-member-${i}`);
				memberElement.setAttribute(`data-member-${newIndex}`, '');

				const labelSpan = memberElement.querySelector('[data-member-number]');
				if (labelSpan) {
					labelSpan.textContent = `${window.accountProfile.customer_member_label} ${newIndex}`;
				}

				const deleteBtn = memberElement.querySelector(
					`[data-delete-member-${i}]`,
				);
				if (deleteBtn) {
					deleteBtn.removeAttribute(`data-delete-member-${i}`);
					deleteBtn.setAttribute(`data-delete-member-${newIndex}`, '');
					deleteBtn.replaceWith(deleteBtn.cloneNode(true));
					const newDeleteBtn = memberElement.querySelector(
						`[data-delete-member-${newIndex}]`,
					);
					newDeleteBtn.addEventListener('click', (e) => {
						e.preventDefault();
						this.deleteMember(newIndex);
					});
				}

				const nameField = memberElement.querySelector(
					`[data-name-member-${i}]`,
				);
				if (nameField) {
					nameField.removeAttribute(`data-name-member-${i}`);
					nameField.setAttribute(`data-name-member-${newIndex}`, '');
					nameField.id = `member-name-${newIndex}`;
				}

				const dobField = memberElement.querySelector(`[data-member-dob-${i}]`);
				if (dobField) {
					dobField.removeAttribute(`data-member-dob-${i}`);
					dobField.setAttribute(`data-member-dob-${newIndex}`, '');
					dobField.id = `member-birthday-${newIndex}`;
				}

				const skinTypeField = memberElement.querySelector(
					`[data-skintype-member-${i}]`,
				);
				if (skinTypeField) {
					skinTypeField.removeAttribute(`data-skintype-member-${i}`);
					skinTypeField.setAttribute(`data-skintype-member-${newIndex}`, '');
					skinTypeField.id = `member-skintype-${newIndex}`;
				}

				const relationshipField = memberElement.querySelector(
					`[data-relationship-member-${i}]`,
				);
				if (relationshipField) {
					relationshipField.removeAttribute(`data-relationship-member-${i}`);
					relationshipField.setAttribute(
						`data-relationship-member-${newIndex}`,
						'',
					);
					relationshipField.id = `member-relationship-${newIndex}`;
				}

				const labels = memberElement.querySelectorAll('label');
				labels.forEach((label) => {
					const forAttr = label.getAttribute('for');
					if (forAttr && forAttr.includes(`-${i}`)) {
						label.setAttribute('for', forAttr.replace(`-${i}`, `-${newIndex}`));
					}
				});

				const memberInArray = this.members.find((m) => m.index === i);
				if (memberInArray) {
					memberInArray.index = newIndex;
				}
			}
		}

		this.memberCount--;
	}

	validateRequiredFields() {
		this.clearValidationErrors();

		let isValid = true;

		if (!this.customerFirstnameField?.value.trim()) {
			this.errorFirstName.classList.remove('u-hidden');
			isValid = false;
		}

		if (!this.customerLastnameField?.value.trim()) {
			this.errorLastName.classList.remove('u-hidden');
			isValid = false;
		}

		return isValid;
	}

	clearValidationErrors() {
		const fieldErrors = this.el.querySelectorAll('.js-field-error');
		fieldErrors.forEach((error) => {
			error.classList.add('u-hidden');
		});
	}

	getCookie(name) {
		const nameEQ = name + '=';
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	setCookie(name, value, days) {
		const expires = new Date();
		expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
		document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
	}

	intlTelInput(inputPhone) {
		const input = inputPhone;
		const cdnIntlTel =
			'https://cdn.jsdelivr.net/npm/intl-tel-input@25.11.3/build/js/utils.js';

		if (input) {
			// Store the instance globally so other scripts can access it
			window.customerPhoneITI = intlTelInput(input, {
				separateDialCode: true,
				nationalMode: true,
				utilsScript: cdnIntlTel,
				initialCountry: 'auto',
				geoIpLookup: (success, failure) => {
					fetch('https://ipapi.co/json')
						.then((res) => res.json())
						.then((data) => success(data.country_code))
						.catch(() => failure());
				},
			});

			input.addEventListener('blur', () => {
				if (window.customerPhoneITI.isValidNumber()) {
					input.removeAttribute('error');
				} else {
					input.setAttribute('error', true);
				}
			});
		}
	}

	findKeyByValue(obj, value) {
		return Object.keys(obj).find((key) => obj[key] === value);
	}

	closePopin() {
		if (this.validateBtns) {
			this.validateBtns.forEach((btn) => {
				btn.addEventListener('click', (e) => {
					e.preventDefault();
					this.popinValidateInfos.classList.add('u-hidden');
					this.setCookie(this.cookieName, 'true', 365 * 10);
					FixScroll.unFix();
				});
			});
		}
	}

	showPopin() {
		if (this.popinValidateInfos) {
			this.popinValidateInfos.classList.remove('u-hidden');
			FixScroll.fix();
		}
	}

	checkIfHasInfos(array) {
		const allowedKeys = ['id', 'email', 'first_name', 'last_name'];

		for (const key in array) {
			if (!allowedKeys.includes(key)) {
				const value = array[key];

				if (
					value !== null &&
					value !== undefined &&
					value !== '' &&
					!(Array.isArray(value) && value.length === 0)
				) {
					return true;
				}
			}
		}

		return false;
	}
}
